// This is a wrapper around our teamsnap sdk since I don't want
// it to be used globally
import 'teamsnap.js/lib/teamsnap';

const teamsnapSdk = () => window.teamsnap;

export default teamsnapSdk;
